export const SHOWN_SALES_START_ONBOARDING_COOKIE_KEY = 'times_shown_sales_start_onboarding';
